<template>
	<button
		@click="handleDirection"
		@keyup.prevent="handleKeyUp"
	>
		<slot />
	</button>
</template>

<script>
export default {
	inject: {
		provider: Symbol.for( 'carousel' ),
	},
	props: {
		direction: {
			type: String,
			required: true,
			validator: ( prop ) => [ 'next', 'previous' ].includes( prop ),
		},
	},

	methods: {
		handleDirection() {
			this.provider.$emit( 'set:direction', this.direction );
		},

		handleKeyUp( event ) {
			const { direction } = this;
			const events = {
				ArrowLeft: direction,
				ArrowRight: direction,
			}[ event.key ];

			if ( events ) {
				this.handleDirection( events );
			}
		},
	},
};
</script>
